import Cookies from 'js-cookie'

let coninoData = {}
try {
    coninoData = JSON.parse(Cookies.get('ConinoData') || '{}')
} catch (error) {
    console.log(error)
}
export const ConinoData = coninoData

export const saveConinoData = function (key, value) {
    const tmp = JSON.parse(Cookies.get('ConinoData') || '{}')
    if (value === undefined) {
        delete tmp[key]
    } else {
        tmp[key] = value
    }
    Cookies.set('ConinoData', JSON.stringify(tmp))
}
